//import { ErrorModel } from '@models';
import { APIKit } from '../axios/index';
import { AppConstants } from '../../constants';
import { CryptoUtils, StorageUtils } from 'utils';
import { AxiosResponse } from 'axios';

const { STORAGE_ACCESS_TOKEN } = AppConstants;
const SECRET_KEY = process.env.REACT_APP_AES_KEY;
const excludeContentTypes = ['multipart/form-data', 'application/zip']

export function setupAPIRequestListener() {
  return APIKit.interceptors.request.use((config) => {
    console.log('[API REQUEST]', config);
    const token = StorageUtils.getObject(STORAGE_ACCESS_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (SECRET_KEY
      && (config.headers['Content-Type']
      && !excludeContentTypes.includes(config.headers['Content-Type'] as string))) {
      if (config.data) {
        config.data = CryptoUtils.encrypt(config.data);
        config.headers['Accept'] = 'application/json';
        config.headers['Content-Type'] = 'application/json';
      }
    } else {
      config.headers['X-Encrypted'] = 'false';
    }
    return config;
  });
}
export function removeAPIRequestListener(apiInterceptor: any) {
  APIKit.interceptors.request.eject(apiInterceptor);
}
export function setupAPIResponseListener() {
  return APIKit.interceptors.response.use(
    async function (response: AxiosResponse<any, any>) {
      console.log('[API RESPONSE]', response);
      if (!!response.data && !!SECRET_KEY && !response.config.headers['X-Encrypted'] && !(response.data instanceof Blob)) {
        response.data = CryptoUtils.decrypt(response.data);
      }
      return response;
    },
    async function (error: any) {
      return Promise.reject(error);
    },
  );
}

export function removeAPIResponseListener(apiInterceptor: any) {
  APIKit.interceptors.response.eject(apiInterceptor);
}